<template>
  <v-container>
    <div class="container-inner">
      <div v-if="!!getActiveWarehouse">
        <div class="pageTitle">
          <v-row>
            <v-col sm="6" md="7" lg="8" cols="12">
              <h1 class="main-title">Locations</h1>
            </v-col>
            <v-col sm="6" md="5" lg="4" cols="12">
              <div class="flex-nowrap align-center input-search">
                <v-text-field
                  v-model="search"
                  placeholder="Search"
                  dense
                  filled
                  Outlined
                  single-line
                  hide-details="auto"
                  prepend-inner-icon="mdi-magnify"
                />
              </div>
            </v-col>
          </v-row>
        </div>
        <breadcrumbs :items="navTableItems" @clickCrumb="handleClickCrumb" />
        <div class="table-wrapper mt-6">
          <controls
            :locationId='navigationPosition.id'
            @on-change="loadData"
          />
          <v-divider />
          <locationsTable
            :headers='tableHeaders'
            :items='list'
            :options='sort'
            :selectAll='computedSelectAll'
            :pagination="pagination"
            @on-change-sort="loadData"
          />
          <pagination :pagination="pagination" />
        </div>
      </div>
      <SelectWarehouse v-else />
    </div>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import breadcrumbs from '@/components/locations/list/breadcrumbs'
import controls from '@/components/locations/list/controls'
import locationsTable from '@/components/locations/list/locationsTable'
import pagination from '@/components/locations/list/pagination'
import SelectWarehouse from '@/views/SelectWarehouse'
export default {
  name: 'Locations',
  components: {
    breadcrumbs,
    controls,
    locationsTable,
    pagination,
    SelectWarehouse
  },
  data() {
    return {
      search: '',
      filter: {
        users: [],
        searchText: null,
        operationType: null,
        dateStart: null,
        dateEnd: null
      },
      navTableItems: [
        {
          id: null,
          text: 'Warehouse'
        }
      ],
      navigationPosition: {
        isGeneral: true,
        id: null
      },
      tableHeaders: [
        {
          text: '',
          align: 'start',
          sortable: false,
          value: 'selected'
        },
        {
          text: 'Name',
          value: '',
          sortable: true,
          align: 'start',
          width: 150,
          sortState: {
            active: false,
            order: false
          }
        },
        {
          text: 'Code',
          value: '',
          sortable: true,
          align: 'start',
          width: 150,
          sortState: {
            active: false,
            order: false
          }
        },
        {
          text: 'Created',
          value: 'createdAt',
          sortable: true,
          align: 'start',
          sortState: {
            active: false,
            order: false
          }
        },
        {
          text: 'Updated',
          value: 'updatedAt',
          sortable: true,
          align: 'start',
          sortState: {
            active: false,
            order: false
          }
        },
        { text: '', value: 'actions', sortable: false, align: 'start' }
      ],
      sort: {
        field: null,
        order: null
      },
      list: [],
      pagination: {
        page: 1,
        pages: 1,
        itemsPerPage: 10
      }
    }
  },
  computed: {
    ...mapGetters('warehouses', ['getActiveWarehouse']),
    computedSearchField: {
      get() {
        return this.searchField
      },
      set(v) {
      }
    },
    computedSelectAll: {
      get() {
        if (this.list.length) return this.list.length === this.selectedItems.length
        return false
      },
      set(v) {
        this.list.forEach(item => {
          item.selected = v
        })
      }
    },
    selectedItems() {
      return this.list.filter(item => item.selected)
    }
  },
  watch: {
    getActiveWarehouse(v) {
      if (v) {
        this.navigationPosition.id = v.id
        this.loadData()
      }
    },
    search() {
      const searchText = this.search.trim()
      if (this.filter.searchText === null && searchText.length < 3) {
        return
      }
      if (this.search.trim().length < 3) {
        this.filter.searchText = null
      } else {
        this.filter.searchText = searchText
      }
      this.$emit('on-change')
    }
  },
  methods: {
    loadData() {
    },
    handleClickCrumb(id) {
    }
  }
}
</script>

<style scoped lang="scss">

</style>
